import { render } from "./AddWebSourceDialog.vue?vue&type=template&id=afa2213e"
import script from "./AddWebSourceDialog.vue?vue&type=script&lang=js"
export * from "./AddWebSourceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__